





















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
    TitleLine: require('@/components/TitleLine').default
  }
})
export default class BaseAction extends Vue {
  @Prop({
    required: true
  })
  title: string

  @Prop()
  saveFunction: Function

  @Prop()
  validation: { message?: string, valid: boolean }

  @Prop({
    default: 'is-primary'
  })
  type: string

  @Prop({
    default: 'Save'
  })
  confirmLabel: string

  @Prop({
    default: 'Cancel'
  })
  closeLabel: string

  loading: boolean = false

  get disabled(): boolean {
    return !this.validation.valid
  }

  close() {
    this.$emit('close')
  }

  setLoading(v: boolean) {
    this.loading = v

    this.$emit('update:loading', v)
  }

  async save() {
    if (this.disabled) return

    this.setLoading(true)

    try {
      const res = await this.saveFunction()

      if (res && res.data && res.data.playlists) {
        this.$store.commit('library/replacePlaylists', res.data)
      }

      this.$emit('save')

      this.close()
    } catch (error) {
      console.error(error)
    }

    this.setLoading(false)
  }
}
